export default function getLocalTime(slot: string): string {
  const [startStr, endStr] = slot.split(' - ');

  const [startHour, startMin] = startStr.split(':').map(Number);
  const [endHour, endMin] = endStr.split(':').map(Number);

  const now = new Date();
  const utcDateStart = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), startHour, startMin));
  const utcDateEnd = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), endHour, endMin));

  const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };

  const localStart = utcDateStart.toLocaleTimeString(undefined, options);
  const localEnd = utcDateEnd.toLocaleTimeString(undefined, options);

  return `${localStart} - ${localEnd}`;
}